/* eslint-disable react-hooks/exhaustive-deps */
import { ChangeEvent, useEffect, useState } from "react"
import { HasId, ID } from "src/libs/interfaces/layouts"
import { ILandingStore, useLandingStore } from "src/modules/pe-landing-module/data/store" 
import { hideOver } from "./utils"

/* Protopia Ecosystem component */
export interface ICheckboxHandlerProps {
    type: string
    item: HasId
    sectionId: ID
    onCheck: ( bool: boolean ) => void
}
const CheckboxHandler = (props: ICheckboxHandlerProps): JSX.Element => { 
    const selectedElements      = useLandingStore((state: ILandingStore) => state.selectedElements)
    const selectedElementsType  = useLandingStore((state: ILandingStore) => state.selectedElementsType)
    const selectedSectionId     = useLandingStore((state: ILandingStore) => state.selectedSectionId)
    const [checked, setChecked] = useState<boolean>( !!selectedElements.find((el: any) => el.id === props.item.id) )
    useEffect(() => {
        const unsubscribe = useLandingStore.subscribe(
            ( state: ILandingStore ) => state.selectedElements,
            ( selectedElements:any[] ) => {               
                setChecked( !!selectedElements.find((el: any) => el.id === props.item.id) ) 
            }, 
            {} 
        )
        return () => {
            unsubscribe()
            displayHide( false )
        };
    }, []) 

    const onCheck = ( evt : ChangeEvent<HTMLInputElement> ) => { 
        const _checked = evt.target.checked
        if( !!_checked ) { 
            if( selectedSectionId === props.sectionId && props.type === selectedElementsType ) {
                useLandingStore.setState({
                    selectedElements : [ ...selectedElements, props.item ],
                })  
            }
            else {
                useLandingStore.setState({
                    selectedElements :  [ props.item ],
                    selectedElementsType: props.type,
                    selectedSectionId: props.sectionId,
                })  
            }
            displayHide( true )
        }
        else {
            useLandingStore.setState({
                selectedElements : selectedElements.filter( (el: any) => el.id !== props.item.id )
            }) 
            displayHide( false )
        } 
    } 

    const displayHide = ( is: boolean ) => {
        setTimeout(() => is ? hideOver( props.sectionId, props.item.id ) : hideOver(), 300) 
    }

    return <div className={`pe-checkbox-handler-container pr-1 ${checked ?  "" : "pe-surface4" }`}>
        <label htmlFor="" className="_check___ m-0">
            <input type="checkbox" checked={ checked } onChange={ onCheck } />
        </label>       
    </div>
}
export default CheckboxHandler